// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountV1PatientUpsearchDefaultResponse {
    static getAttributeTypeMap() {
        return AccountV1PatientUpsearchDefaultResponse.attributeTypeMap;
    }
}
AccountV1PatientUpsearchDefaultResponse.discriminator = undefined;
AccountV1PatientUpsearchDefaultResponse.additionalProperties = false;
AccountV1PatientUpsearchDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PatientUpSearchResultModel"
    },
];
//# sourceMappingURL=accountV1PatientUpsearchDefaultResponse.js.map